import { useEffect } from "react";
import ServicesSection from "../sections/ServicesSection";
import ApplicationFormSection from "../sections/ApplicationFormSection";

const ServicesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full">
      <ServicesSection />
      <ApplicationFormSection />
    </div>
  );
};

export default ServicesPage;

